import { ReactElement } from "react";
import Create from "@shared/FormTemplates/Create";
import CreateForm from "./CreateForm";
import createItemAPI from "@services/Clients/RocketFactory/timeline/createItem";
import validator from "@validators/Clients/RocketFactory/timeline/timeline.validate";
import formMapper from "@mappers/Clients/RocketFactory/timeline/timelineItem.mapper";

const CreateItem = (): ReactElement => (
  <Create
    CustomForm={CreateForm}
    createHook={createItemAPI}
    validator={validator}
    formMapper={formMapper}
  />
);

export default CreateItem;
